import { datatypes, inputTypes } from "data/globalData";
import { catalogActiveStatusColumn } from "../shared/catalogMasterUi";

export const ZIPPER_PULLER_CATALOGS = {
	ZIPPER_TYPES: "zipper_types",
	PULLERS: "pullers",
	PULLER_SIZES: "puller_sizes",
	METAL_FINISHES: "metal_finishes",
	TAPE_COLORS: "tape_colors",
	MERCHANT_SIZES: "merchant_sizes",
};

export const zipperPullerCatalogTabs = [
	{ key: ZIPPER_PULLER_CATALOGS.ZIPPER_TYPES, name: "Zipper Types" },
	{ key: ZIPPER_PULLER_CATALOGS.PULLERS, name: "Pullers" },
	{ key: ZIPPER_PULLER_CATALOGS.PULLER_SIZES, name: "Puller Sizes" },
	{ key: ZIPPER_PULLER_CATALOGS.METAL_FINISHES, name: "Metal Finishes" },
	{ key: ZIPPER_PULLER_CATALOGS.TAPE_COLORS, name: "Tape Colors" },
	{ key: ZIPPER_PULLER_CATALOGS.MERCHANT_SIZES, name: "Merchant Sizes" },
];

const baseColumn = (name, key, inputType = inputTypes.ENTER.key, required = false) => ({
	name,
	key,
	data_type: datatypes.STRING.key,
	input_type: inputType,
	constraints: { NOTNULL: required, DISPLAY: true },
});

export const zipperPullerCatalogPrimaryKeys = {
	[ZIPPER_PULLER_CATALOGS.ZIPPER_TYPES]: "zipper_type_code",
	[ZIPPER_PULLER_CATALOGS.PULLERS]: "puller_code",
	[ZIPPER_PULLER_CATALOGS.PULLER_SIZES]: "id",
	[ZIPPER_PULLER_CATALOGS.METAL_FINISHES]: "metal_finish_code",
	[ZIPPER_PULLER_CATALOGS.TAPE_COLORS]: "tape_color_code",
	[ZIPPER_PULLER_CATALOGS.MERCHANT_SIZES]: "merchant_size",
};

export const zipperPullerEditableFields = {
	[ZIPPER_PULLER_CATALOGS.ZIPPER_TYPES]: ["size", "zipper_type", "open_close", "code", "active_status"],
	[ZIPPER_PULLER_CATALOGS.PULLERS]: ["active_status"],
	[ZIPPER_PULLER_CATALOGS.PULLER_SIZES]: ["default_metal_finish", "active_status"],
	[ZIPPER_PULLER_CATALOGS.METAL_FINISHES]: ["metal_finish_name", "active_status"],
	[ZIPPER_PULLER_CATALOGS.TAPE_COLORS]: ["active_status"],
	[ZIPPER_PULLER_CATALOGS.MERCHANT_SIZES]: ["active_status"],
};

export const zipperPullerCreatableFields = {
	[ZIPPER_PULLER_CATALOGS.ZIPPER_TYPES]: ["size", "zipper_type", "open_close", "code", "active_status"],
	[ZIPPER_PULLER_CATALOGS.PULLERS]: ["puller_code", "active_status"],
	[ZIPPER_PULLER_CATALOGS.PULLER_SIZES]: ["puller_code", "size", "default_metal_finish", "active_status"],
	[ZIPPER_PULLER_CATALOGS.METAL_FINISHES]: ["metal_finish_name", "active_status"],
	[ZIPPER_PULLER_CATALOGS.TAPE_COLORS]: ["tape_color_code", "active_status"],
	[ZIPPER_PULLER_CATALOGS.MERCHANT_SIZES]: ["merchant_size", "active_status"],
};

export const zipperPullerAutoPrimaryKeyCatalogs = new Set([
	ZIPPER_PULLER_CATALOGS.ZIPPER_TYPES,
	ZIPPER_PULLER_CATALOGS.METAL_FINISHES,
	ZIPPER_PULLER_CATALOGS.PULLER_SIZES,
]);

export const zipperPullerCatalogColumns = {
	[ZIPPER_PULLER_CATALOGS.ZIPPER_TYPES]: [
		baseColumn("Code", "zipper_type_code"),
		baseColumn("ERP Code", "code", inputTypes.ENTER.key, true),
		baseColumn("Size", "size", inputTypes.ENTER.key, true),
		baseColumn("Zipper Type", "zipper_type", inputTypes.ENTER.key, true),
		baseColumn("Open/Close", "open_close", inputTypes.ENTER.key, true),
		catalogActiveStatusColumn,
	],
	[ZIPPER_PULLER_CATALOGS.PULLERS]: [
		baseColumn("Puller Code", "puller_code", inputTypes.ENTER.key, true),
		catalogActiveStatusColumn,
	],
	[ZIPPER_PULLER_CATALOGS.PULLER_SIZES]: [
		baseColumn("Puller Code", "puller_code", inputTypes.ENTER.key, true),
		baseColumn("Size", "size", inputTypes.ENTER.key, true),
		baseColumn("Puller Size Code", "puller_size_code"),
		baseColumn("Default Metal Finish", "default_metal_finish"),
		catalogActiveStatusColumn,
	],
	[ZIPPER_PULLER_CATALOGS.METAL_FINISHES]: [
		baseColumn("Code", "metal_finish_code"),
		baseColumn("Metal Finish", "metal_finish_name", inputTypes.ENTER.key, true),
		catalogActiveStatusColumn,
	],
	[ZIPPER_PULLER_CATALOGS.TAPE_COLORS]: [
		baseColumn("Tape Color Code", "tape_color_code", inputTypes.ENTER.key, true),
		catalogActiveStatusColumn,
	],
	[ZIPPER_PULLER_CATALOGS.MERCHANT_SIZES]: [
		baseColumn("Merchant Size", "merchant_size", inputTypes.ENTER.key, true),
		catalogActiveStatusColumn,
	],
};

export const getZipperPullerRowId = (catalog, row) => {
	switch (catalog) {
		case ZIPPER_PULLER_CATALOGS.ZIPPER_TYPES:
			return row.zipper_type_code;
		case ZIPPER_PULLER_CATALOGS.PULLERS:
			return row.puller_code;
		case ZIPPER_PULLER_CATALOGS.PULLER_SIZES:
			return row.id ?? `${row.puller_code}-${row.size}`;
		case ZIPPER_PULLER_CATALOGS.METAL_FINISHES:
			return row.metal_finish_code;
		case ZIPPER_PULLER_CATALOGS.TAPE_COLORS:
			return row.tape_color_code;
		case ZIPPER_PULLER_CATALOGS.MERCHANT_SIZES:
			return String(row.merchant_size);
		default:
			return row.id;
	}
};
